import { render, staticRenderFns } from "./MenuBlock.vue?vue&type=template&id=b6b6d52c&scoped=true"
import script from "./MenuBlock.vue?vue&type=script&lang=js"
export * from "./MenuBlock.vue?vue&type=script&lang=js"
import style0 from "./MenuBlock.vue?vue&type=style&index=0&id=b6b6d52c&prod&scoped=true&lang=scss"
import style1 from "./MenuBlock.vue?vue&type=style&index=1&id=b6b6d52c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b6d52c",
  null
  
)

export default component.exports